import { Component } from '@angular/core';
import { HeaderLayoutComponent } from '../../shared/layouts/header-layout/header-layout.component';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent {

}
